export const siteData = {
  clinic: {
    name: "The Acupuncture & Fire Cupping Clinic",
    phone: "(714) 681-2785",
    fax: "(714) 790-1991",
    email: "drkang@pwmedicalgroup.com",
    bookingUrl: "https://pwmg.setmore.com",
    intakeUrl: "https://new.pwmedicalgroup.com/",
    smsNumber: "+17146812785",
  },
  doctor: {
    name: "Dr. Jonghan Kang",
    displayName: "Dr. Jonghan Kang (강종한)",
    title: "Ph.D. / L.Ac. / CMT / NCCAOM",
    fullTitle: "Licensed Acupuncturist & Certified Massage Therapist",
    credentials: "California & Hawaii Licensed Acupuncturist",
    image: "https://customer-assets.emergentagent.com/job_6f97fa01-f9ae-4a36-ae9a-6c8fa7654bd0/artifacts/bf7suizu_6b37d34a-ab4a-40f6-9bdd-046c958501c2.png",
    bio: "Dr. Kang combines traditional Eastern medicine with modern therapeutic techniques to provide immediate pain relief and long-term recovery. His approach focuses on treating the root cause, not just the symptoms.",
    highlights: [
      { title: "Credentials", description: "California & Hawaii Licensed Acupuncturist / Certified Massage Therapist" },
      { title: "Experience", description: "2016년부터 현재까지 10년 이상의 통증 관리 전문 임상 경력, 2,000명 이상의 환자 치료" },
    ],
    stats: [
      { value: "10+", label: "Years Experience" },
      { value: "2k+", label: "Patients Treated" },
    ],
    mediaFeature: "미주 조선일보(Chosun Daily) 등 주요 언론이 주목한 통증 전문가",
  },
  services: [
    {
      id: "integrative",
      title: "Acupuncture & Fire Cupping",
      subtitle: "Fire Cupping 30min + Acupuncture 20min",
      description: "불부항과 침 치료를 병행하여 신경통 및 고질적인 통증을 입체적으로 관리.",
      descriptionEn: "Precision needle placement for targeted pain relief. Dr. Kang's expertise in locating exact pain points delivers measurable results from the very first session.",
      highlights: ["Chronic Pain Relief", "Sports Injury Recovery", "Nerve Pain Treatment"],
      price: 150,
      duration: "50 min",
      icon: "sparkles",
      image: "https://images.unsplash.com/photo-1598555763574-dca77e10427e?w=600&h=400&fit=crop&q=80",
    },
    {
      id: "massage",
      title: "Medical Massage & Fire Cupping",
      subtitle: "Fire Cupping 30min + Medical Massage 10min",
      description: "부항 치료의 효과를 극대화하기 위한 숙련된 수기 치료 병행.",
      descriptionEn: "Certified medical massage & fire cupping targeting deep tissue pain and dysfunction. Complements acupuncture to promote circulation, reduce inflammation, and accelerate recovery.",
      highlights: ["Deep Tissue Therapy", "Pain Management", "Injury Rehabilitation"],
      price: 150,
      duration: "40 min",
      icon: "heart",
      image: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&h=400&fit=crop&q=80",
    },
    {
      id: "cupping",
      title: "Royal Fire Cupping",
      subtitle: "Fire Cupping 30min",
      description: "통증 부위를 정밀 타격하는 정통 불부항 시술.",
      descriptionEn: "Traditional fire cupping therapy using heated glass cups to create suction on the skin, promoting blood flow, relieving muscle tension, and accelerating natural healing for chronic pain conditions.",
      highlights: ["Blood Circulation", "Muscle Tension Relief", "Toxin Release"],
      price: 80,
      duration: "30 min",
      icon: "flame",
      image: "https://rejua.in/wp-content/uploads/2019/01/Fire-Cupping-Treatment-imn-min-1.jpg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    },
  ],
  navigation: [
    { label: "New Patient Form", href: "https://new.pwmedicalgroup.com/", external: true },
    { label: "Services", href: "#services" },
    { label: "Dr. Kang", href: "#doctor" },
    { label: "Locations", href: "#locations" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Gongjindan", href: "#gongjindan" },
  ],
  gongjindan: {
    title: "Premium Gongjindan",
    subtitle: "The Ultimate Restorative Herbal Medicine",
    description: "Experience the power of traditional wisdom. Our Gongjindan is handcrafted with the highest quality herbs to restore energy, improve focus, and strengthen your body's natural resilience.",
    url: "https://gongjindan365.com/",
    highlights: ["100% Premium Herbs", "Energy & Vitality", "Immune System Support"],
    image: "https://gongjindan365.com/images/product_1.png",
  },
  hero: {
    headline: "Precision Healing. Lasting Relief.",
    subheadline:
      "Specialized Pain Management through Acupuncture and Fire Cupping by Dr. Jonghan Kang. Expert care for neck, shoulder, and back pain.",
    primaryCta: { label: "Book Your Appointment", url: "https://pwmg.setmore.com" },
    secondaryCta: { label: "Call (714) 681-2785", url: "tel:+17146812785" },
  },
  specializations: [
    {
      id: "acupuncture",
      title: "Acupuncture & Fire Cupping",
      description:
        "Precision needle placement for targeted pain relief. Dr. Kang's expertise in locating exact pain points delivers measurable results from the very first session.",
      highlights: ["Chronic Pain Relief", "Sports Injury Recovery", "Nerve Pain Treatment"],
      image:
        "https://images.unsplash.com/photo-1598555763574-dca77e10427e?w=600&h=400&fit=crop&q=80",
    },
    {
      id: "massage",
      title: "Medical Massage & Fire Cupping",
      description:
        "Certified medical massage & fire cupping targeting deep tissue pain and dysfunction. Complements acupuncture to promote circulation, reduce inflammation, and accelerate recovery.",
      highlights: ["Deep Tissue Therapy", "Pain Management", "Injury Rehabilitation"],
      image:
        "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&h=400&fit=crop&q=80",
    },
    {
      id: "cupping",
      title: "Royal Fire Cupping",
      description:
        "Traditional fire cupping therapy using heated glass cups to create suction on the skin, promoting blood flow, relieving muscle tension, and accelerating natural healing for chronic pain conditions.",
      highlights: ["Blood Circulation", "Muscle Tension Relief", "Toxin Release"],
      image:
        "https://rejua.in/wp-content/uploads/2019/01/Fire-Cupping-Treatment-imn-min-1.jpg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    },
  ],
  problemSolver: {
    title: "The Problem Solver",
    subtitle: "For Chronic Pain & Sports Injuries",
    description:
      "Dr. Kang doesn't just treat symptoms \u2014 he finds the root cause. With professional licenses across multiple states and nearly two decades of dedicated practice since 2006, his precise diagnostic approach identifies pain sources that others miss.",
    stats: [
      { value: "10+", label: "Years of Experience" },
      { value: "3", label: "Professional Licenses" },
      { value: "2000+", label: "Patients Treated" },
    ],
  },
  testimonials: [
    {
      id: 1,
      quote:
        "After the first treatment my pain improved by 60%. I couldn't believe the difference after just one session with Dr. Kang.",
      author: "Sarah M.",
      rating: 5,
      condition: "Chronic Back Pain",
    },
    {
      id: 2,
      quote:
        "Dr. Kang found the exact location of my pain within 2 minutes. His precision is unlike anything I've experienced before.",
      author: "Michael R.",
      rating: 5,
      condition: "Shoulder Injury",
    },
    {
      id: 3,
      quote:
        "I've tried everything for my neck pain. Dr. Kang was the first practitioner to actually diagnose what was wrong and provide lasting relief.",
      author: "Jennifer L.",
      rating: 5,
      condition: "Chronic Neck Pain",
    },
    {
      id: 4,
      quote:
        "The holistic approach here is what sets Pure Wave apart. My anxiety has decreased significantly since starting treatment.",
      author: "David K.",
      rating: 5,
      condition: "Anxiety & Stress",
    },
  ],
  locations: [
    {
      id: 1,
      name: "Placentia",
      facility: "Wellness Within Chiropractic",
      address: "1525 N Placentia Ave",
      crossStreet: "Placentia Ave & Palm Dr",
      city: "Placentia, CA 92870",
      hours: "Tue & Thu: 9:00 AM – 6:00 PM",
      shortHours: "Tue/Thu 9AM–6PM",
      mapQuery: "1525+N+Placentia+Ave,+Placentia,+CA",
    },
    {
      id: 2,
      name: "Anaheim",
      facility: "Rasta Wellness & Chiropractic",
      address: "611 S Harbor Blvd",
      crossStreet: "Harbor Blvd & Water St",
      parkingInfo: "Parking is behind the building on Water St.",
      city: "Anaheim, CA 92805",
      hours: "Mon, Wed & Fri: 9:30 AM – 6:30 PM",
      shortHours: "Mon/Wed/Fri 9:30AM–6:30PM",
      mapQuery: "611+S+Harbor+Blvd,+Anaheim,+CA",
    },
    {
      id: 3,
      name: "La Habra",
      facility: "Nature Acupuncture",
      address: "860 E La Habra Blvd",
      crossStreet: "La Habra Blvd & Harbor Blvd",
      city: "La Habra, CA 90631",
      hours: "Mon – Fri: 10:00 AM – 6:00 PM",
      shortHours: "Mon–Fri 10AM–6PM",
      mapQuery: "860+E+La+Habra+Blvd,+La+Habra,+CA",
    },
  ],
  insurance: [
    "Triwest VA (Veterans)",
    "Workers' Compensation",
    "Various Insurance Providers",
    "Flexible Payment Options",
    "Credit Cards Accepted",
  ],
  amenities: [
    { text: "LGBTQ+ Friendly", icon: "heart" },
    { text: "Safe Neighborhood", icon: "shield" },
    { text: "Private Treatment Rooms", icon: "door" },
    { text: "Easy Parking", icon: "car" },
    { text: "Credit Cards Accepted", icon: "creditCard" },
    { text: "Comfortable Environment", icon: "smile" },
  ],
  newsArticle: {
    title: "\uAC01\uC885 \uAD00\uC808\uD1B5\u00B7\uC2E0\uACBD\uD1B5\u00B7\uC694\uD1B5\uCE58\uB8CC \uB9E1\uACA8\uB9CC \uC8FC\uC138\uC694",
    titleEn: "Leave All Joint, Nerve & Back Pain Treatment to Us",
    source: "Chosun Daily (\uBBF8\uC8FC\uC870\uC120\uC77C\uBCF4)",
    date: "February 21, 2023",
    summary: "Dr. Kang has been recognized as a highly skilled pain specialist by the Korean-American community. Operating from the same location since 2006, his expertise in acupuncture, cupping, and massage has earned him a reputation for providing remarkable relief \u2014 often from the very first treatment.",
    quote: "\uD5C8\uB9AC\uC640 \uBAA9, \uC5B4\uAE68 \uB4F1\uC5D0 \uD1B5\uC99D\uC774 \uC2EC\uD55C \uD658\uC790\uB4E4\uC744 \uCE68\uACFC \uBD80\uD56D \uADF8\uB9AC\uACE0 \uB9C8\uC0AC\uC9C0\uB85C \uCDA9\uBD84\uD788 \uC644\uD654\u00B7\uC644\uCF8C\uB420 \uC218 \uC788\uB3C4\uB85D \uCE58\uB8CC\uD569\uB2C8\uB2E4.",
    quoteEn: "I treat patients suffering from severe pain in the back, neck, and shoulders with acupuncture, cupping, and massage until they can fully recover.",
    url: "https://chosundaily.com/bbs/board.php?bo_table=hotclick&wr_id=11700",
  },
};

export const images = {
  hero: "https://scontent-lax3-1.cdninstagram.com/v/t51.75761-15/494694305_18500263594012157_824444955028323805_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=110&ig_cache_key=MzYyMDg4MjUzNzY3NzAwNzg2Mg%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=A66K7hz6IlkQ7kNvwH-QxB5&_nc_oc=AdkJ3e92hFrZ8HS099b51Ieqj_IOthztsb4_ZHmSszwdKUKFLOuwtm7Ba3U4dBK_X-JOk3CPt8SSncW9KKgcg0Y3&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-lax3-1.cdninstagram.com&_nc_gid=YYbxDSII7cmeUuShDvvtYQ&oh=00_AftR6Oa0G1kLuDTjsY2aQ1pkxjTv7y4AEnfy1sfERg8jMQ&oe=699BFBC5",
  acupuncture:
    "https://images.unsplash.com/photo-1598555763574-dca77e10427e?w=600&h=400&fit=crop&q=80",
  massage:
    "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&h=400&fit=crop&q=80",
  cupping:
    "https://rejua.in/wp-content/uploads/2019/01/Fire-Cupping-Treatment-imn-min-1.jpg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
  wellness:
    "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?w=600&h=400&fit=crop&q=80",
};
